<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm02">
<a id="pagexvii"></a>
<div class="chapterHead">
<h2 class="chapterTitle1"> </h2></div>
<div class="chapterBody">
<p class="chapterOpenerText"><span class="bold"><em class="italic">It’s time for you to learn to Rule Your Freakin’ Retirement! Get with the program!</em></span></p>
<a id="pagexviii"></a>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ruleyourfreakinretirement_fm02.vue?0d98863c